<template>
<div class="z-main">
	<header class="z-header">
		<div>
			<router-link :to="{path:'/futures/kline',query:$route.query}">
				<img class="hearIcon" src="../../assets/sysbars/left.png">
			</router-link>
		</div>
		<div v-text="$route.query.fname" style="color:#E2B96F;"></div>
		<div>&nbsp;</div>
	</header>
	<div class="z-body z-body-bottom0" :style="{height:(windowHeight-50)+'px'}">
	<section class="z-kline-qy"  style="justify-content: flex-start;">
		<div>{{$t('资产')}}：<span style="color:red;font-size:16px;" v-text="amount_before+mine.amount+amount_after"></span></div>
		<!-- <div>权益：{{topDataTotal}}</div>
		<div>可用：{{topDataAmount}}</div>
		<div>使用率：{{topDataUseRate}}%</div> -->
	</section>

	<section class="z-theme-bg2">
		<div class="z-newest-info" style="width: 100%;">
			<div class="darkTab">
				<div style="width: 15%;">{{$t('新')}}</div>
				<div style="width: 40%;">{{dataContent.last_price}}</div>
				<div style="width: 45%;text-align: right">{{dataContent.volume}}</div>
			</div>
			<div class="darkTab">
				<div style="width: 15%;">{{$t('卖')}}</div>
				<div style="width: 40%;">{{dataContent.sell_price}}</div>
				<div style="width: 45%;text-align: right">{{dataContent.sell_volume}}</div>
			</div>
			<div class="darkTab">
				<div style="width: 15%;">{{$t('买')}}</div>
				<div style="width: 40%;">{{dataContent.buy_price}}</div>
				<div style="width: 45%;text-align: right">{{dataContent.buy_volume}}</div>
			</div>
		</div>
	</section>

	<!-- 表格 -->
	<section style="border-top: 1px solid #515151;">
	    <div style="background: #fff;">

			<!-- 表格-表头 -->

			<v-tabs slot="extension" v-model="tabs" centered color="#fff" slider-color="red">
				<v-tab v-on:click="flootBtnOn" class="titleTab dark-color" :key="1">
					{{$t('持仓')}}
				</v-tab>
				<v-tab v-on:click="openRegister" class="titleTab dark-color" :key="2">
					{{$t('挂单')}}
				</v-tab>
				<v-tab v-on:click="openDeal" class="titleTab dark-color" :key="3">
					{{$t('成交')}}
				</v-tab>
			</v-tabs>
	    </div>
		<!-- 表格-数据 -->
		<v-tabs-items touchless style="color: rgb(35,35,35);" v-model="tabs">
			<!--持仓内容-->
			<v-tab-item :key="1" style="overflow-x:scroll;">
				<div class="z-table">
					<div class="z-table-header">
						<div class="z-table-row">
							<div>{{$t('名称')}}</div>
							<div>{{$t('浮盈')}}</div>
							<div>{{$t('操作')}}</div>
							<div>{{$t('手续费')}}</div>
							<div>{{$t('多空')}}</div>
							<div>{{$t('总仓')}}</div>
							<div>{{$t('可用')}}</div>
							<div>{{$t('开仓均价')}}</div>

						</div>
					</div>
					<div class="z-table-content">
						<div class="z-table-row" v-for="item in haldingData">
							<div>{{item.fname}}</div>
							<div v-bind:class="item.fyprice>0? 'fontGreen':'fontRed'">{{item.fyprice}}</div>
							<div @click="pingcang(item.id)">
								<span style="color:#1867c0;"><b>{{$t('平仓')}}</b></span>
							</div>
							<div>{{item.poundage}}</div>
							<div>{{item.multi_empty==1 ? $t('多') : $t('空') }}</div>
							<div>{{item.total}}</div>
							<div>{{item.enable_num}}</div>
							<div>{{item.avg_price}}</div>

						</div>
					</div>
				</div>
			</v-tab-item>
			<!--挂单部分内容-->
			<v-tab-item :key="2">
				<v-card>
					<div class="contentNavTab">
						<div style="width: 25%;">{{$t('名称')}}</div>
						<div style="width: 25%;">{{$t('开平')}}</div>
						<div style="width: 25%;">{{$t('委托价')}}</div>
						<!-- <div style="width: 25%;">委托量</div>
						<div style="width: 25%;">挂单量</div> -->
						<div style="width: 25%;">{{$t('操作')}}</div>
					</div>
					<div v-for="(item,index) in registerDataComtent">
					<!-- v-bind:class="registerChooseNumber==index?'lineBox':''" -->
						<div
							class="contentTabBox">
							<div style="width: 25%;">{{item.fname}}</div>
							<div v-bind:class="item.kp==$t('买开')?'fontRed':'fontGreen'" style="width: 25%;">{{item.kp}}</div>
							<div style="width: 25%;"><input style="border:1px solid #FFB800;width:100%;" type="number" v-model="item.wt_price" @change="priceUpdate($event,item.id)">
							</div>
							<!-- <div style="width: 25%;">{{item.wt_nums}}</div>
							<div style="width: 25%;">{{item.gd_num}}</div> -->
							<div style="width: 25%;" >
								<span style="color:#1867c0;" @click="cancelOrder(item.id)"><b>{{$t('撤单')}}</b></span>
							</div>
						</div>
						<!-- <div
							v-if="registerChooseNumber==index"
							style="color: lightgray;text-align: right;padding: 6px 0">
							<div
								v-if="registerDataComtent[registerChooseNumber].isDelete==false"
								v-on:click="registerDataComtent[registerChooseNumber].isDelete=true;registerDataComtent.push('');registerDataComtent.pop()"
								style="width: 100px;display: inline-block;padding: 4px 10px;background-color: rgb(190,56,65);text-align: center">
								撤单
							</div>
							<div
								v-if="registerDataComtent[registerChooseNumber].isDelete==true"
								v-on:click="cancelOrder(item.id)"
								style="width: 150px;display: inline-block;padding: 4px 10px;background-color: rgb(190,56,65);text-align: center">
								是否确认撤单
							</div>
						</div> -->
					</div>
				</v-card>
			</v-tab-item>
			<!--成交内容-->
			<v-tab-item :key="3">
				<v-card>
					<div class="contentNavTab">
						<div style="width: 16%;">{{$t('名称')}}</div>
						<div style="width: 16%;">{{$t('手续费')}}</div>
						<div style="width: 16%;">{{$t('开平')}}</div>
						<div style="width: 16%;">{{$t('价格')}}</div>
						<div style="width: 16%;">{{$t('成交量')}}</div>
						<div style="width: 20%;">{{$t('时间')}}</div>
					</div>
					<div v-for="item in dealDaraContent" class="contentTabBox">
						<div style="width: 16%;">{{item.fname}}</div>
						<div style="width: 16%;">{{item.poundage}}</div>
						<div v-bind:class="item.kp=='买开' || item.kp=='卖开'?'fontRed':'fontGreen'" style="width: 16%;">{{$t(item.kp)}}</div>
						<div style="width: 16%;">{{item.clinch_price}}</div>
						<div style="width: 16%;">{{item.clinch_num}}</div>
						<div style="width: 20%;">{{item.clinch_time}}</div>
					</div>
				</v-card>
			</v-tab-item>
		</v-tabs-items>
	</section>


	<div v-if="loadBox" class="text-xs-center loadCircular">
		<v-progress-circular :size="50" color="primary" indeterminate></v-progress-circular>
	</div>


	<!-- 弹出砍认框 -->
	<v-dialog v-model="dialog.show" max-width="290">
		<v-card light>
		<v-card-title class="headline">{{dialog.title}}</v-card-title>
		<v-card-text>{{dialog.content}}.</v-card-text>
		<v-card-actions>
		<v-spacer></v-spacer>
		<v-btn color="green darken-1" flat="flat" @click="dialogCancel">{{$t('取消')}}</v-btn>
		<v-btn color="green darken-1" flat="flat" @click="dialogSuccess">{{$t('同意')}}</v-btn>
		</v-card-actions>
		</v-card>
	</v-dialog>
	</div>
</div>
</template>

<script>
export default {
	inject:['reload'],
	name: 'transaction',
	data() {
		return {
			mine:{
		  		amount:0
		  	},
			fname:'',
			tabs: null,
			flootBtnOnOff:false,    //持仓合计开关
			dataContent:{},      //现在所选的合约信息
			type:null,          //现在选择的类型  0为实盘 1为模拟
			typeBox:false,      //选择交易类型弹窗开关
			chooseNumber:null,      //持仓所选的下标
			choosemulti_empty:null,   //当前所选中的合约的‘多空’状态
			registerDataComtent:[],    //挂单的列表信息
			registerChooseNumber:-1,   //挂单现所选的下标
			entrustDataContent:[],      //委托列表信息
			dealDaraContent:[],       //成交列表信息
			repairprice:false,       //修改价格弹窗开关
			changePriceData:{},     //现在要改变的价格
			changePriceInput:"",    //改变的价格

			mode: 'multi-line',
			timeout: 2000,
			text: '',
			lockPositionBottom:this.$t('平仓'),
			timer:null,
			heartBox:null,
			priceType:this.$t('对手价'),
			m_price:null,   //做多价格
			e_price:null,    //做空价格
			p_price:null,    //平仓价格
			addMoreText:[0,0],
			handNum:null,     //手数
			loadBox:true,     //缓冲动画开关
			topDataTotal:'',    //顶部当前权益信息
			topDataAmount:'',    //顶部可用资金信息
			topDataUseRate:'',    //顶部使用率信息
			inputActive:null,       //输入框开关
			mp:0,                  //当前所选合约的‘卖出’状态
			miniDifference:0,     //最小变动价格
			dialog:{
				show:false,//显示关态
				type:null,//弹出类型
				title:this.$t('你确定吗'),
				content:this.$t('弹出说明文本'),
				resolve:null,//创建的promise resolve函数
				reject:null,//创建的promise reject
				isConfirm:false//当前点击按钮类型 false为取消 true为确认
			},
			is_submit_ing:0,//是否提交中
			//长连接-轮询检测状态
			eventInterval:null,
			//长连接-轮询发送持仓请求
			holdInterval:null,
			//持仓数据
			haldingData:[],
			//长连接断开后重连
			colseEvent:null,
			//持仓轮询发送长连接
			holdSendLoop:null
		}
	},
	created(){
		this.getMine()
	},
	mounted() {
		let _this = this
		_this.fname = _this.$route.query.fname
		//初始化
		_this.initData()
		//轮询发送持仓
		_this.holdSendLoop = setInterval(function() {
			_this.holding()
		}, 2000)
	},
	watch:{
		'$store.state.webscoketObj.readyState':function (newV) { //监听长连接状态
			let _this = this
			_this.colseEvent = setTimeout(function () {
				_this.initData()
				_this.reload()
			},1500)
		},
	},
	methods: {
		// 个人信息
		getMine:function () {
			//会员信息
			this.get('api/users/center', {}).then((res) => {
				if (res.code == 0) {
					this.mine = res.data
					this.topDataAmount = res.data.amount
				}
			})
		},
		wsSend() {//长连接 - 发送盘口数据
			let _this = this
			let request = JSON.stringify({
				action:'Futures',
				data:{
					token:_this.getToken(),
					list:_this.$route.query.code
				}
			})

			//长连接状态正常才发送
			if (_this.$store.state.webscoketObj) {
				if (_this.$store.state.webscoketObj.readyState==1) {
					clearInterval(_this.eventInterval)
					_this.$store.state.webscoketObj.send(request)
					_this.$store.state.webscoketObj.onmessage = _this.wsReceive
				}
			}
			else { //长连接状态不正常，则轮询
				_this.eventInterval = setInterval(function () {
					clearInterval(_this.eventInterval)
					_this.wsSend()
				},1000)
			}
		},
		wsSendHold(){ //长连接 - 发送持仓数据
			let _this = this
			let request = JSON.stringify({
				action:'hold'
			})
			if (_this.$store.state.webscoketObj && _this.$store.state.webscoketObj.readyState==1) {
				_this.$store.state.webscoketObj.send(request)
			}
		},
		wsReceive(e) { //长连接 - 数据接收（行情、持仓）
			let _this = this;
			const redata=JSON.parse(e.data);
			if (redata && redata.action=='UpdateOrder' && redata.data.status==1) { //下单成功
				_this.initData()
			}
			else if(redata && redata.type=="hangqing"){ //行情
				this.dataContent.last_price=redata.data[0].last_price
				this.dataContent.volume=redata.data[0].volume
				this.dataContent.sell_price=redata.data[0].sell_price
				this.dataContent.sell_volume=redata.data[0].sell_volume
				this.dataContent.buy_price=redata.data[0].buy_price
				this.dataContent.buy_volume=redata.data[0].buy_volume
				if(this.e_price==null){
					if(this.priceType==this.$t('对手价')){
						if(this.mp==1){
							this.p_price=redata.data[0].buy_price
						}
						else if(this.mp==2){
							this.p_price=redata.data[0].sell_price
						}
					}
				}
				if(this.e_price!=null){
					if(this.priceType==this.$t('排队价')){
						this.m_price=redata.data[0].buy_price
						this.e_price=redata.data[0].sell_price
						if(this.mp==1){
							this.p_price=redata.data[0].sell_price
						}
						else if(this.mp==2){
							this.p_price=redata.data[0].buy_price
						}
					}
					else if(this.priceType==this.$t('对手价')) {
						this.m_price=redata.data[0].sell_price
						this.e_price=redata.data[0].buy_price
						if(this.mp==1){
							this.p_price=redata.data[0].buy_price
						}
						else if(this.mp==2){
							this.p_price=redata.data[0].sell_price
						}
					}
					else if(this.priceType==this.$t('最新价')){
						this.m_price=redata.data[0].last_price
						this.e_price=redata.data[0].last_price
						if(this.mp==1){
							this.p_price=redata.data[0].last_price
						}else if(this.mp==2){
							this.p_price=redata.data[0].last_price
						}
					}
					else if(this.priceType==this.$t('超价')){
						this.m_price=(parseFloat(redata.data[0].sell_price)+this.miniDifference).toFixed(2).toString()
						this.e_price=(parseFloat(redata.data[0].buy_price)-this.miniDifference).toFixed(2).toString()
						if(this.mp==1){
							this.p_price=(parseFloat(redata.data[0].buy_price)-this.miniDifference).toFixed(2).toString()
						}
						else if(this.mp==2){
							this.p_price=(parseFloat(redata.data[0].sell_price)+this.miniDifference).toFixed(2).toString()
						}
					}
				}
			}
			else if(redata && redata.type=="hold"){ //持仓
				_this.setHolding(redata.data)
			}
		},
		//初始化数据
		initData:function () {
			let _this = this
			_this.post('api/Trade/init.html', {
				fid:_this.$route.query.fid
			}).then((res) => {
				if(res.code==0){
					_this.dataContent=res.data
					_this.handNum=res.data.hand_num
					_this.wsSend()
				}
				else {
					this.$store.commit('layer',res.msg)
				}
			})

			//持仓
			_this.holding()
		},
		flootBtnOn:function () {
			this.flootBtnOnOff=true
		    // 请求持仓数据
		    this.holding()
		},
		//成交数据
		openDeal:function () {
			this.post('api/Trade/Bargain.html', {}).then((res) => {
				if(res.code==0){
					this.dealDaraContent=res.data
				}
				else {
					this.$store.commit('layer',res.msg)
					if(res.msg==this.$t('token值错误！')){
						this.jump('/user/login')
					}
				}
			})
		},
		//持仓数据
		holding(){
			let _this = this
			_this.post('api/Trade/Holding.html', {}).then((rs) => {
				if(rs.code==0){
					_this.setHolding(rs.data)
				}
				else {
					this.$store.commit('layer',rs.msg)
					_this.loadBox=false
				}
				// //轮询发送持仓
				// _this.holdSendLoop = setInterval(function() {
				// 	_this.wsSendHold()
				// }, 2000)
			})
		},
		//设置持仓数据格式
		setHolding(data){
			let _this = this
			_this.topDataTotal= data.money.total //权益
			_this.topDataAmount= data.money.amount //可用
			_this.topDataUseRate= data.money.useRate //使用率
			_this.haldingData =  data.list //持仓列表
			_this.loadBox=false
		},
		// 显示弹出框
		dialogOpt(type,price){
			let name = this.dataContent.fname
			let handNum = this.handNum
			let typeText = ""
			if (type=='addMore') {
				typeText = this.$t('买入')
			}
			else if(type=='addSpace') {
				typeText = this.$t('卖出')
			}
			price=price || '';
			let content=typeText+': '+name+handNum+this.$t('手')+' '+price;
			return {
				title:this.$t('确定交易')+"?",
				content:content
			}
		},
		showDialog(opts){
			return new Promise((resolve,reject)=>{
				this.dialog.show=true;
				this.dialog.title=opts.title;
				this.dialog.content=opts.content;
				this.dialog.resolve = resolve;
				this.dialog.reject = reject;
			});
		},
		closeDialog(){
			//重置
			this.dialog.show=false;
			this.dialog.title=null;
			this.dialog.content=null;
			this.dialog.resolve = null;
			this.dialog.reject = null;
		},
		dialogSuccess(){
			this.dialog.resolve();
			this.closeDialog();
		},
		dialogCancel(){
			this.dialog.reject();
			this.closeDialog();
		},
		//买入
		addMore:function () {
			let price=null
			let _this = this
			if(this.e_price==null && this.priceType==this.$t('对手价')){
				price=this.dataContent.sell_price
			}
			else if(this.e_price==null && this.priceType!=this.$t('对手价')){
				price=this.priceType
			}
			else if(this.e_price!=null){
				price=this.m_price
			}

			if (this.is_submit_ing==1) {
				return false
			}

			this.showDialog(this.dialogOpt('addMore',price)).then(()=>{
				this.is_submit_ing = 1
				this.post('api/Trade/DownOrder.html', {
					analog:this.type,
					fid:this.dataContent.fid,
					hand_num:this.handNum,
					price:price,
					mp:1
				}).then((res) => {
					this.is_submit_ing = 0
					this.getMine()
					this.$store.commit('layer',res.msg)
				})
			}).catch(()=>{
				this.is_submit_ing = 0

			});
		},
		//卖出
		addSpace:function () {
			let price=null
			let _this = this
			if(this.e_price==null && this.priceType==this.$t('对手价')){
				price=this.dataContent.buy_price
			}
			else if(this.e_price==null && this.priceType!=this.$t('对手价')){
				price=this.priceType
			}
			else if(this.e_price!=null){
				price=this.e_price
			}

			if (this.is_submit_ing==1) {
				return false
			}

			this.showDialog(this.dialogOpt('addSpace',price)).then(()=>{
				this.is_submit_ing = 1
				this.post('api/Trade/DownOrder.html', {
					analog:this.type,
					fid:this.dataContent.fid,
					hand_num:this.handNum,
					price:price,
					mp:2
				}).then((res) => {
					this.is_submit_ing = 0
					this.getMine()
					this.$store.commit('layer',res.msg)
				})
			}).catch(()=>{
				this.is_submit_ing = 0

			});
		},
		// 挂单列表
		openRegister:function () {
			this.get('api/trade/PutOrder', {}).then((res) => {
				if(res.code==0){
					this.registerDataComtent=res.data
					for(let i=0;i<res.data.length;i++){
						this.registerDataComtent[i].isDelete=false   //增加确认删除的属性
					}
				}else {
					this.$store.commit('layer',res.msg)
				}
			})
		},
		registerChangeChooseNumber:function (e) {
			if (this.registerChooseNumber==e) {
				this.registerChooseNumber=-1
			}
			else {
				this.registerChooseNumber=e
			}

		},
		// 改价
		priceUpdate:function (event,id) {
			this.post('api/trade/ChangePrice', {
				id:id,
				wt_price:event.currentTarget.value
			}).then((res) => {
				this.$store.commit('layer',res.msg)
				if(res.code==0){
					this.openRegister()
				}
			})
		},
		// 撤单
		cancelOrder:function (id) {
			this.showDialog({title:this.$t('撤单'),content:this.$t('确定要撤单')+'？'}).then(()=>{
				this.is_submit_ing = 1

				this.post('api/Trade/Cancal.html', {
					id:id
				}).then((res) => {
					this.$store.commit('layer',res.msg)
					if(res.code==0){
						this.openRegister()
					}
					this.is_submit_ing = 0
					this.$store.commit('layer',res.msg)
				})
			}).catch(()=>{
				this.is_submit_ing = 0

			});
		},
		// 手动平仓
		pingcang:function (id) {
			let _this = this
			this.showDialog({title:this.$t('平仓'),content:this.$t('确定要手动平仓')+'？'}).then(()=>{
				this.is_submit_ing = 1
				this.post('api/Trade/pingcang.html', {
					id:id
				}).then((res) => {
					this.$store.commit('layer',res.msg)
					if(res.code==0){
						setTimeout(function () {
							_this.getMine()
						},1000)
						this.holding()
					}
					this.is_submit_ing = 0
					this.$store.commit('layer',res.msg)
				})
			}).catch(()=>{
				this.is_submit_ing = 0

			});
		},

	},
	destroyed:function () {
		let _this = this;
		clearInterval(_this.timer)
    	clearInterval(_this.eventInterval)
    	clearInterval(_this.holdInterval)
    	clearTimeout(_this.colseEvent)
    	clearInterval(_this.holdSendLoop)
	},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*表格*/
.z-table-header,
.z-table-content,
.z-table-row {
	width: 620px;
	display: -webkit-flex;
  	display: flex;

}
.z-table,
.z-table-header,
.z-table-content {
	display: block;
  	overflow: scroll;
	flex-direction: column;
}
.z-table {
	width: 100%;
  	padding: 10px;
}
.z-table-header {
	color: #8B8B88;
	border-bottom: 1px dashed gray;
}
.z-table-row {
	flex-direction: row;
  	padding-bottom: 10px;
}
.z-table-content .z-table-row{
	padding-top: 15px;
  color: #fff;
}
.z-table-row div {
	text-align: center;
	width: 60px;
}
.z-table-row div:nth-child(4),
.z-table-row div:nth-child(5),
.z-table-row div:nth-child(6),
.z-table-row div:nth-child(7),
.z-table-row div:nth-child(8) {
	width: 100px;
}



a{
color: lightgray;
text-decoration: none;
}
.hearIcon{
	width:20px;
	height:20px;
}

.contentBox{
width:100%;
background-color:rgb(65,65,65);
margin-bottom:5px;
font-size: 12px;
}
.mainContentLeft{
width: 48%;
display: inline-block;
}
.mainContentLeft >div{
overflow: hidden;
white-space: nowrap;
text-overflow: ellipsis;
padding:3px 0 3px 0;
}
.fontGray{
color:rgb(192,192,192) ;
}
.fontGreen{
color: #00ef09;
}
.fontRed{
color: #ff0000;
}
.v-menu__content{
position: static;
}
.v-picker__body{
width:220px;
}
.titleBox{
background-color: #20232A;
display: flex;
padding:10px 0;
justify-content:space-around;
}
.titleBox >div{
margin-right: 10px;
}
.darkTab{
width: 100%;
display: flex;
justify-content: space-around;
text-align: center;
}
.darkTab >div{
width:30%;
overflow: hidden;
text-overflow: ellipsis;
white-space: nowrap;
}


.entrustNavTab{
white-space: nowrap;
}
.entrustNavTab >div{
display: inline-block;
text-align: center;
padding:4px;
background-color: rgb(107,107,107);
margin:0px 0px 0px -3px;
border-right:1px solid rgb(53, 56, 75);
}
.entrustConten{
white-space: nowrap;
}
.entrustConten >div{
color: lightgray;
display: inline-block;
text-align: center;
padding:10px 4px;
margin:-2px 0px 0px -3px;
border-bottom: 1px solid black;
border-right:1px solid black;
}
.lineBox{
background-color: rgb(233,99,0);
}
.outBox{
height: 100%;
overflow:auto;
overflow-x:hidden;
background-color: #20232A;
position:relative;
padding-bottom: 58px;
font-size: 15px;
color:#8B8B88;
}

.changeTypeBox{
width: 100%;
height: 100%;
background-color: rgba(0,0,0,0.4);
z-index: 333;
position: absolute
}
.changeTypeBox >div{
position: absolute;
top: 0px;
bottom: 28px;
left: 0px;
right: 0px;
margin: auto;
width: 300px;
height: 116px;
background-color: rgb(48,48,48);
}
.changeTypeBtn{
padding: 0px 20px;
height: 50px;
display: flex;
font-size: 20px;
justify-content: space-between;
align-items: center;
}
.repairpriceBox{
width: 100%;
height: 100%;
background-color: rgba(0,0,0,0.4);
z-index: 333;
position: absolute
}
.repairpriceBox >div{
position: absolute;
top: 0px;
bottom: 100px;
left: 0px;
right: 0px;
margin: auto;
width: 300px;
height: 193px;
background-color: rgb(48,48,48);
}
.repairpriceBoxTop{
display: flex;
padding: 15px 0px 10px 20px;
align-items: center;
}
.loadCircular{
position: absolute;
top: 0px;
left: 0px;
bottom: 0px;
right: 0px;
margin: auto;
width: 60px;
height: 60px;
}
.line{
border-top: 1px solid rgba(255,255,255,0.3);
margin: 0px 10px
}
.inputActive{
border:1px solid orangered;
}
.theme--light{
background-color:#fff;
color:#000;
}
.z-theme-bg {
background-color: #20232A;
}
.z-theme-bg2 {
	margin:10px;
	display: flex;
	justify-content: space-around;
	color: lightgray;
}
.z-trade-buy {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	align-self:flex-end;
	margin-top: 10px;
}
.z-trade-hy {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	border:1px solid #8B8B88;
	justify-content: space-between;
	padding: 5px;
	border-radius: 5px;
	color: #8B8B88;
}
.z-newest-info{
	display: flex;
	display: -webkit-flex;
	align-items:center;
	align-content:center;
	flex-direction:column;
	border:1px solid #515151;
	border-radius: 5px;
	padding: 5px;
	color:#8B8B88;
}
.z-newest-info>div{
	height: 31%;
}
.z-newest-btns{
	display: flex;
	display: -webkit-flex;
	align-items:center;
	justify-content:space-around;
	color: white;
	margin:10px;
}
.z-newest-btns>div{
	padding: 5px 20px;
	border-radius: 5px;
	text-align: center;
	width: 48%;
}
.contentNavTab{
	display: flex;
	background-color: #20232A;
	color: #fff;
}
.contentNavTab >div{
	color: #8B8B88;
	border: none;
	text-align: center;
	padding:4px;
	font-size: 14px;
}
.contentTabBox{
	color: #fff;
	display: flex;
	/*justify-content: space-between;*/
	background: #20232A;
  flex-direction: row;
}
.contentTabBox >div{
	text-justify: newspaper;
word-break: break-all;
	text-align: center;
	padding:10px 4px;
}
.titleTab{
	width: 33%;
	background-color:#20232A;
  color:#fff;
	font-size: 16px;
	border-bottom: 1px solid #515151;

}
.z-Kline-header{
	height: 60px;
	font-size: 18px;
	color: white;
	padding:0 10px;
	justify-content:space-between;
	background-color: #20232A;
	border-bottom:1px solid #424355;
}
.z-kline-qy {
	display: flex;
	display: -webkit-flex;
	align-items: center;
	justify-content: space-around;
	background: #1b2c42;
	padding: 10px;
	margin-bottom: 10px;
	color: #fff;
}


</style>



// WEBPACK FOOTER //
// src/pages/futures/transaction.vue